import React from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useCoefficientData } from "hooks/configs/relance/useCoefficientData";
import { useCoefficientForm } from "hooks/configs/relance/useCoefficientForm";
import { PermissionGuard } from "components/configs/relance/PermissionGuard";
import { PageHeader } from "components/configs/relance/PageHeader";
import { CoefficientInput } from "components/configs/relance/CoefficientInput";
import { FormActions } from "components/configs/relance/FormActions";
import { LoadingSpinner } from "components/configs/relance/LoadingSpinner";
import { ErrorMessage } from "components/configs/relance/ErrorMessage";

const ConfigCoefficient = (props) => {
  const { t, ready } = useTranslation();

  const { data, isLoading, error } = useCoefficientData();
  const {
    formData,
    errors,
    isSubmitting,
    updateField,
    handleSubmit,
  } = useCoefficientForm(data);

  const onChangeCoef = (e) => {
    updateField("coef", e.target.value);
  };

  // eslint-disable-next-line no-unused-vars
  const onChangedomaine_prefixe = (mail) => {
    updateField("domaine_prefixe", mail);
  };

  return (
    <PermissionGuard userPermissions={props.userPermissions} ready={ready}>
      <div
        className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
        id="kt_content"
      >
        <PageHeader t={t} />

        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="row">
            <div className="col">
              <div className="kt-portlet">
                <div className="kt-portlet__head">
                  <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                      {t("Coefficient")}
                    </h3>
                  </div>
                </div>

                <form method="POST" className="kt-form">
                  <div className="kt-portlet__body">
                    {error && <ErrorMessage error={error} t={t} />}

                    {isLoading ? (
                      <LoadingSpinner t={t} />
                    ) : (
                      <div className="row">
                        <CoefficientInput
                          value={formData.coef}
                          onChange={onChangeCoef}
                          errors={errors.coef}
                          t={t}
                        />

                        {/* Commented out domain prefix field - preserved for future use */}
                        {/* 
                        <div className="col col-12 col-md-6">
                          <div className={errors?.domaine_prefixe.length ? "col validated" : "col"}>
                            <label htmlFor="email">
                              {t("Préfix des mails")}
                              <InputRequire />
                            </label>
                            <TagsInput
                              value={formData.domaine_prefixe || []}
                              onChange={onChangedomaine_prefixe}
                              inputProps={{
                                className: "react-tagsinput-input",
                                placeholder: "Domaines des e-mails",
                              }}
                            />
                            {errors.domaine_prefixe.length ? 
                              errors.domaine_prefixe.map((error, index) => (
                                <div key={index} className="invalid-feedback">
                                  {error}
                                </div>
                              )) : null
                            }
                          </div>
                        </div> 
                        */}
                      </div>
                    )}
                  </div>

                  <FormActions
                    isSubmitting={isSubmitting}
                    onSubmit={handleSubmit}
                    t={t}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PermissionGuard>
  );
};

const mapStateToProps = (state) => ({
  userPermissions: state.user.user.permissions,
});

export default connect(mapStateToProps)(ConfigCoefficient);
